import { PlansDurationType } from '@localstack/types';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { ReactElement } from 'react';
import { styled } from '@mui/material/styles';

type Props = {
  selectedInterval: PlansDurationType;
  onChange: (interval: PlansDurationType) => void;
};

const StyledToggleButton = styled(ToggleButton)(() => ({
  padding: 4,
  fontSize: 11,
  flex: 1,
  minWidth: 55,
}));

export const BillingIntervalToggle = ({ selectedInterval, onChange }: Props): ReactElement => {
  return (
    <ToggleButtonGroup
      exclusive
      onChange={(_, value) => onChange(value ?? selectedInterval)}
      value={selectedInterval}
      size="small"
      onClick={(e) => e.stopPropagation()}
    >
      <StyledToggleButton value={PlansDurationType.MONTHLY} color="primary">
        Monthly
      </StyledToggleButton>
      <StyledToggleButton value={PlansDurationType.YEARLY} color="primary">
        Yearly
      </StyledToggleButton>
    </ToggleButtonGroup>
  );
};
